import DotMantis from 'mantis/components/@extended/Dot';

const Dot = (props) => {
	return <DotMantis {...props} />;
};

export default Dot;
